export const userLogin = async (username, password) => {
    return await fetch(`${import.meta.env.VITE_API_PATH}/dg_login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username,
            password,
        }),
    });
}

export const getUser = async (token) => {
    return await fetch(`${import.meta.env.VITE_API_PATH}/dg_get_user`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
}